import { Project, Text } from "@nova/protobuf"
import {
    booleanValidator,
    colorValidators,
    createLayerValidator,
    enumValidator,
    genericUpdateLayerValidator,
    latitudeValidators,
    longitudeValidators,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
import { LineWidth } from "@nova/constants"

const textValidators = [
    {
        validator: (text: string) => text.length < 1000,
        error: "Text cannot be longer than 1000 characters",
    },
]
const rotationValidators = [
    {
        validator: (rotation: number) => rotation >= 0 && rotation <= 360,
        error: "Rotation is out of bounds",
    },
]

const fontSizeValidators = [
    {
        validator: (fontSize: number) => fontSize > 0,
        error: "Font size cannot be negative",
    },
]

const widthValidators = enumValidator("LineWidth", LineWidth)

const textEntityValidators = {
    longitude: {
        validators: longitudeValidators,
        nonNull: true,
    },
    latitude: {
        validators: latitudeValidators,
        nonNull: true,
    },
    text: {
        validators: textValidators,
        nonNull: true,
    },
    rotation: {
        validators: rotationValidators,
        nonNull: true,
    },
    fontSize: {
        validators: fontSizeValidators,
        nonNull: true,
    },
    baseFontSize: {
        validators: fontSizeValidators,
        nonNull: true,
    },
    color: {
        validators: colorValidators,
        nonNull: true,
    },
    bold: {
        validators: booleanValidator("Bold"),
        nonNull: true,
    },
    outlineColor: {
        validators: colorValidators,
        nonNull: true,
    },
    outlineWidth: {
        validators: widthValidators,
        nonNull: true,
    },

    parentId: genericUpdateLayerValidator.parentId,
    index: genericUpdateLayerValidator.index,
} as const

// some weird type stuff happens when you try to move the outer defined validators into the object
// don't copy this pattern when making a new layer validator, copy from any other file
export const createTextValidator = createLayerValidator(Text, textEntityValidators)
export const updateTextValidator = updateLayerValidator(Text, textEntityValidators)

export const getDefaultTextCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreateTextArgs = UnionToTuple<keyof typeof createTextValidator>
export type UpdateTextArgs = UnionToTuple<keyof typeof updateTextValidator>
